import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';

import Button from '@style-guide/components/Button';

import FormFieldSet from '@components/FormFieldSet';
import FormFieldWrapper from '@components/FormFieldWrapper';
import ReduxFormCheckboxGroup from '@components/ReduxFormCheckboxGroup';

// A7/#233: native <fieldset disabled> guarantees every descendant control is disabled at the DOM
// level, regardless of whether the @osba/style-guide Checkbox honors its own `disabled` prop. The
// border/margin/padding reset keeps the resting (Aptify, not-read-only) layout visually unchanged.
const LockableFieldSet = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;

  &:disabled {
    /* A7/#233: guarantee no interaction + a clearly-disabled look even if a descendant checkbox is
       a non-native control that <fieldset disabled> alone would not neutralize. */
    pointer-events: none;
    opacity: 0.6;
  }
`;

LockableFieldSet.displayName = 'LockableFieldSet';

class PracticeAreasForm extends React.Component {
  // the ReduxFormCheckboxGroup just requires a array of strings to make checkboxes from
  // we receive an array of objects with ID so we need to flatten it to just an array of names
  static flattenPracticeAreaArray(whichArray) {
    return (whichArray.map(item => item.name));
  }

  render() {
    return (
      <form
        id="practiceAreasForm"
        onSubmit={values => this.props.handleSubmit(values)}
      >
        <LockableFieldSet disabled={this.props.readOnly}>
          <FormFieldWrapper>
            <FormFieldSet>
              <Field
                name="SelectedPracticeAreas"
                props={{
                  options: PracticeAreasForm.flattenPracticeAreaArray(this.props.practiceAreas),
                  columns: 4,
                  disabled: this.props.readOnly,
                }}
                onChange={this.props.checkLimitHandler}
                component={ReduxFormCheckboxGroup}
              />
            </FormFieldSet>
          </FormFieldWrapper>
        </LockableFieldSet>
        {!this.props.readOnly && (
          <Button
            type="submit"
            disabled={(this.props.pristine || this.props.loading) || this.props.hasSaveError}
          >
            Save
          </Button>
        )}
      </form>
    );
  }
}


PracticeAreasForm.propTypes = {
  practiceAreas: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  hasSaveError: PropTypes.bool,
  pristine: PropTypes.bool,
  readOnly: PropTypes.bool,
  checkLimitHandler: PropTypes.func.isRequired,
};


PracticeAreasForm.defaultProps = {
  hasSaveError: false,
  loading: true,
  practiceAreas: [],
  pristine: true,
  readOnly: false,
};

PracticeAreasForm.displayName = 'PracticeAreasForm';

export default reduxForm({
  form: 'practiceAreasForm',
  enableReinitialize: true,
})(PracticeAreasForm);
